/**
 * Utilitários compartilhados para validação e manipulação de dados de ferramentas
 */

/**
 * Interface base para dados de ferramenta
 */
export interface ToolDataBase {
	code?: string;
	defaults?: Record<string, any>;
	[id: string]: any;
}

/**
 * Valida estrutura básica de dados de ferramenta
 * 
 * @param data - Dados a serem validados
 * @returns true se os dados são válidos
 */
export function validateToolData(data: any): boolean {
	if (!data || typeof data !== "object") {
		return false;
	}

	// Validar que tem código (string não vazia)
	if (!data.code || typeof data.code !== "string" || data.code.trim().length === 0) {
		return false;
	}

	// Validar que tem defaults (objeto)
	if (!data.defaults || typeof data.defaults !== "object") {
		return false;
	}

	return true;
}

/**
 * Valida estrutura de dados de ferramenta com validação customizada
 * 
 * @param data - Dados a serem validados
 * @param customValidate - Função de validação customizada adicional
 * @returns true se os dados são válidos
 */
export function validateToolDataWithCustom(
	data: any,
	customValidate?: (data: any) => boolean
): boolean {
	if (!validateToolData(data)) {
		return false;
	}

	// Aplicar validação customizada se fornecida
	if (customValidate && !customValidate(data)) {
		return false;
	}

	return true;
}

/**
 * Aplica defaults de uma ferramenta usando uma função de setter
 * 
 * @param data - Dados da ferramenta com defaults
 * @param applyDefaults - Função que recebe os defaults e aplica aos estados
 */
export function applyToolDefaults<T extends ToolDataBase>(
	data: T | null,
	applyDefaults: (defaults: Record<string, any>) => void
): void {
	if (!data?.defaults) {
		return;
	}

	try {
		applyDefaults(data.defaults);
	} catch (error) {
		console.warn("[TOOL_DATA_UTILS] Erro ao aplicar defaults:", error);
	}
}

